import React, {useState, useEffect} from 'react';
import {DialogWindow} from  './general';
import { Chip, Stack, Badge, Box, Button, Typography, TextField, FormControl, OutlinedInput, InputAdornment, InputLabel, Card, Collapse, IconButton } from '@mui/material';
import ImageUpload from './productImageUpload'
import { addService } from '../services/item';
import { useSnackbar } from '../context/snackbarContext.js';
import dayjs from 'dayjs'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
//₹

const downloadInvoice = (url, id) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = `${id}_invoice.jpg`;
    link.click();
}

const Delta = ({delta}) => {
    return (
        <Typography sx={{ml:2, fontWeight: 'bold', color: delta < 0 ? 'red': 'green'}}>
            ₹ {Math.abs(delta)}
        </Typography>
    )
}
const AddServiceHistory = ({setShowAdd, handleAdd}) => {
    const [invoiceUrl, setInvoiceUrl] = useState()
    const [invoicePhoto, setInvoicePhoto] = useState()
    const [cropOpen, setCropOpen] = useState(false)
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [serviceCharge, setServiceCharge] = useState(0)
    const [error, setError] = useState(false)

    const handleDeleteInvoicePhoto = () => {
      setInvoicePhoto()
      setInvoiceUrl()
    };

    const handleSave = (e) => {
        if (title.trim()) {
            setError(false)
            handleAdd(title.trim(), description, serviceCharge, invoicePhoto)
        } else{
            setError(true)
        }
    }

    return (
        <Box>
            <Box sx={{width: '100%', height: '100%', display: 'flex', flexDirection:'row', mb: 2}}>
                <Box sx={{width: '60%', display: 'flex', flexDirection:'column'}}>
                    <TextField error={error} helperText={error && "Title is required"} value={title} onChange={(e) => {setTitle(e.target.value)}} sx={{mb: 2}} label="Title*" variant="outlined"/>
                    <TextField value={description} sx={{mb: 2}} onChange={(e) => {setDescription(e.target.value)}} label="Description"  multiline rows={4} variant="outlined"/>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="outlined-adornment-amount">Amount</InputLabel>
                        <OutlinedInput
                            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                            label="Service Charge"
                            value={serviceCharge}
                            onChange={(e)=>{
                                let onlyNums = e.target.value.replace(/[^0-9]/g, "");
                                if (onlyNums.length > 1) {
                                    onlyNums = onlyNums.replace(/^0+/, "");
                                }
                                setServiceCharge(onlyNums)}
                            }
                        />
                    </FormControl>
                </Box>
                <Box sx={{width: '55%', ml: 4}}>
                    <Typography sx={{mb: 0.5}}>Invoice Photo</Typography>
                     <ImageUpload
                        avatarUrl={invoiceUrl}
                        setFile={setInvoicePhoto}
                        label="Invoice Photo"
                        size="medium"
                        setAvatarUrl={setInvoiceUrl}
                        setCropOpen={setCropOpen}
                        aspectRatio={4/5}
                        onDelete={handleDeleteInvoicePhoto}
                        isSquare
                        type="invoice"
                    />
                </Box>
            </Box>
            <Box sx={{display: 'flex', flexDirection:"row", justifyContent:'flex-end'}}>
                <Button variant='outlined' onClick={()=>{setShowAdd(false)}} sx={{mr: 2}}>Back</Button>
                <Button variant='contained' onClick={handleSave}>Save</Button>
            </Box>
        </Box>
    )
}

const IndHeadItem = ({label, value, prefix}) => {
    return (
        <Stack direction="row">
            <Typography>{label}</Typography>
            <Typography sx={{ml:2}}>{prefix} {value}</Typography>
        </Stack>
    )
}

const IndServiceCard = ({service, id, index}) => {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <Card sx={{mb: 1}}>
            <Stack direction="row" sx={{padding: 1, position: 'relative'}} alignItems="center">
                <Typography sx={{width: '60%', fontWeight: 'bold'}}>{service.title}</Typography>
                <Typography sx={{width: '20%'}}>{dayjs(service.createdAt).format("DD/MM/YYYY")}</Typography>
                <Typography sx={{width: '10%'}}>₹ {service.serviceCharge}</Typography>
                <IconButton onClick={()=>{setIsOpen(!isOpen)}} sx={{position: 'absolute', right: 10, transform: isOpen? 'rotate(180deg)' : 'rotate(0deg)' }}><KeyboardArrowDownIcon/></IconButton>
            </Stack>
            <Collapse in={isOpen}>
                <Box sx={{padding: 1}}>
                    <Typography sx={{mb:2, ml:1}}>{service.description}</Typography>
                    {service?.invoice?.url && (<Button onClick={()=>{downloadInvoice(service?.invoice?.url, `${id}_${index}`)}} variant='outlined' endIcon={<FileDownloadIcon fontSize="small"/>}>
                        Downlolad Invoice
                    </Button>)}
                </Box>
            </Collapse>
        </Card>
    )
}

const ServiceHistory = ({serviceHistory, id}) => {
    if (Array.isArray(serviceHistory) && serviceHistory.length > 0) {
        return  (
            <Box sx={{height: '70%', overflowY: 'scroll'}}>
                {serviceHistory.reverse().map((service, index)=> <IndServiceCard service={service} id={id} index={index} key={`service-${index}`}/>)}
            </Box>
        )
    }
    return (
            <Typography sx={{mt: 2, ml: 2}}>No Recrods found</Typography>
        )
}

const Detail = ({selectedItem, setShowAdd, serviceHistory, totalServiceCharges, delta}) =>{
    
    return (
        <Box sx={{height: '50vh', position: 'relative'}}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb:1}}>
                <IndHeadItem label="Purchase Price" value={selectedItem.purchasePrice} prefix="₹"/>
                <IndHeadItem label="Cumulative Rent" value={selectedItem?.cumulativeRent ?? 0} prefix="₹"/>
                <IndHeadItem label="Bookings" value={selectedItem?.bookings ?? 0}/>
                <IndHeadItem label="Service Charges" value={totalServiceCharges} prefix="₹"/>
            </Stack>
            <Typography variant="h6" sx={{mb:1}}>Service History ({serviceHistory.length})</Typography>
            <ServiceHistory serviceHistory={serviceHistory} id={selectedItem._id}/>
            <Button onClick={()=>{setShowAdd(true)}} sx={{position:'absolute', bottom:0, right: 0}} variant='contained'>Add Service History</Button>
        </Box>
    )
}

const Body = ({selectedItem, setDelta}) => {

    const [showAdd, setShowAdd] = useState(false)
    const [serviceHistory, setServiceHistory] = useState([])
    
    const [totalServiceCharges, setTotalServiceCharges] =  useState(0);
    const { showSnackbar } = useSnackbar();

    useEffect(()=>{
        const _totalServiceCharges = serviceHistory.reduce((acc, item) => acc+=item.serviceCharge, 0)
        setTotalServiceCharges(_totalServiceCharges)
        setDelta((selectedItem?.cumulativeRent ?? 0) - (_totalServiceCharges + (selectedItem?.purchasePrice ?? 0)))
    }, [serviceHistory])
    useEffect(()=>{
        if (selectedItem) {
            setServiceHistory(selectedItem?.serviceHistory ?? [])
        }
    }, [selectedItem])

    const handleAdd = async(title, description, serviceCharge, image) => {
        const formData = new FormData();
        formData.append("data", JSON.stringify({title: title, description: description, serviceCharge: serviceCharge}))
        
        if (image) {
            formData.append('invoice', image)
        }
        try {
            const _data = await addService(selectedItem._id, formData)
            setShowAdd(false)
            setServiceHistory(_data.serviceHistory)
            showSnackbar(`Service history added!`, "success")
        } catch (e) {
            console.log(e)
            showSnackbar(`Could not add service history!`, "error")
        }
    }
    if (showAdd) {
        return (<AddServiceHistory setShowAdd={setShowAdd} handleAdd={handleAdd}/>)
    }
    return <Detail
            selectedItem={selectedItem}
            serviceHistory={serviceHistory}
            setShowAdd={setShowAdd}
            totalServiceCharges={totalServiceCharges}
        />
  }



export default function ItemDetail({selectedItem, open, setOpen}) {
    const [delta, setDelta] = useState(0)
    return (
        <DialogWindow
          title={<Stack direction="row" alignItems="center">
            <Typography>{selectedItem.sku} </Typography>
            <Delta delta={delta}/>
          </Stack>}
          Body={<Body selectedItem={selectedItem} setDelta={setDelta}/>}
          Actions={null}
          open={open}
          setOpen={setOpen}
          maxWidth={'md'}
        />
    )
}
